import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
@Component({
    selector: 'product-view-wishlist-toggle',
    templateUrl: 'product-view-wishlist-toggle.html',
    standalone: true,
    imports: [ActionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewWishlistToggleComponent extends WishlistToggleComponentDef {}
// .wishlist-button {
//     width: core.px-to-rem(48);
//     height: core.px-to-rem(48);
//     background-color: color.get(5);
//     border-radius: unset;
// }
